import { ImageAITransformationOutputEntity } from "~/interfaces/entities/ImageAITransformationOutput"
import { createEntitySlice } from "../createEntitySlice"

export const {
  slice: imageAITransformationOutputs,
  selectors: imageAITransformationOutputsSelectors,
} = createEntitySlice<ImageAITransformationOutputEntity>(
  "imageAITransformationOutputs"
)
